import { AuthProvider } from './AuthProvider';
import { I18nProvider } from './I18nProvider';
import { LocaleProvider } from './LocaleProvider';
import { SnackbarProvider } from './SnackbarProvider';
import { UserPreferencesProvider } from './UserPreferencesProvider';

const AppProviders = ({ children }) => (
  <SnackbarProvider>
    <AuthProvider>
      <LocaleProvider>
        <UserPreferencesProvider>
          <I18nProvider>
            { children }
          </I18nProvider>
        </UserPreferencesProvider>
      </LocaleProvider>
    </AuthProvider>
  </SnackbarProvider>
);

export default AppProviders;
